import * as goldenrush from './Content.styles.goldenrush';
import * as juicybet from './Content.styles.juicybet';
import * as puntcity from './Content.styles.puntcity';
import * as sterlingparker from './Content.styles.sterlingparker';
import * as vikingbet from './Content.styles.vikingbet';
import * as forsport from './Content.styles.forsport';
import * as junglebet from './Content.styles.junglebet';
import * as oldgill from './Content.styles.oldgill';
import * as sugarcastle from './Content.styles.sugarcastle';
import * as buffalobet from './Content.styles.buffalobet';
import * as titanbet from './Content.styles.titanbet';
import * as bet777 from './Content.styles.bet777';
import * as gigabet from './Content.styles.gigabet';
import * as slambet from './Content.styles.slambet';
import * as betstride from './Content.styles.betstride';
import * as templebet from './Content.styles.templebet';
import * as goldenbet888 from './Content.styles.goldenbet888';
import * as hyperbet from './Content.styles.hyperbet';
import * as chromabet from './Content.styles.chromabet';
import * as bet575 from './Content.styles.bet575';
import * as betblast from './Content.styles.betblast';
import * as pyramidbet from './Content.styles.pyramidbet';
import * as magnumbet from './Content.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  goldenrush,
  juicybet,
  puntcity,
  sterlingparker,
  vikingbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
